/**
 * Plano de assinatura devolvido por POST /contracts/{id}/validate-for-signature (AF-4138).
 * Contrato: services/contracts/validate-for-signature-response.schema.json.
 */
export interface PlannedSigner {
    name: string;
    email: string;
}

export interface PlannedRole {
    role: string;
    participantSource: 'ASSIGNOR' | 'RECIPIENT' | 'ANY';
    label: string;
    required: boolean;
    signers: PlannedSigner[];
}

export interface SigningStep {
    order: number;
    roles: PlannedRole[];
}

/** Plano da resposta da validação; null quando o backend não devolveu plano. */
export const parseSigningPlan = (validation: unknown): SigningStep[] | null => {
    const plan = (validation as { signingPlan?: SigningStep[] | null } | null)?.signingPlan;
    return Array.isArray(plan) ? plan : null;
};
